import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { PURCHASES_BANNER_TYPE } from '../const';
import { getPurchasesBannerData, setPurchasesBannerType } from '../store/slices/catalogSlice';

const useABBannerTesting = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const bannerType = searchParams.get('banner-type');
    const { title: storageBannerTitle } = useSelector(getPurchasesBannerData);
    const title = PURCHASES_BANNER_TYPE[bannerType] || storageBannerTitle || PURCHASES_BANNER_TYPE['0'];

    const clearSearchParams = useCallback(() => {
        searchParams.has('banner-type');
        setSearchParams(searchParams, { replace: true });
    }, [searchParams, setSearchParams]);

    useEffect(() => {
        if (!bannerType) {
            return;
        }
        dispatch(setPurchasesBannerType(title));
        clearSearchParams();
    }, [bannerType, dispatch, title]);
};

export default useABBannerTesting;
